import React, { useEffect, useState } from "react";
import SideBar from "./Sidebar";
import "./layout.css";
import Header from "./Header"; 
import SimpleSnackbar from "../SnackBar/SnackBar";
import { useSelector } from "react-redux";
 
const Layout = ({ children}) => {
  const isError = useSelector((state) => state.auth.isError);
  const errMsg = useSelector((state) => state.auth.errMsg);
  const authData = useSelector((state) => state.auth.data);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    if (isError) {
      setOpen(true);
      setMsg(errMsg);
    }
  }, [isError]);

  return (
    <div className="layout">
      <SimpleSnackbar
        open={open}
        message={msg}
        variant={'error'}
        handleClose={() => {
          setOpen(false);
          setMsg("");
        }}
      />
      <SideBar />
      <div className="content">
        <Header name={authData?.username}/>
       
        {children}
      </div>
    </div>
  );
};

export default Layout;
